/* @flow */

import * as React from 'react';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';

import styles from './Feed.style';

import { feedGetSponsorToInsert } from 'src/shared/ui/base/util/feedUtils';

type Props<T> = {
  renderItem: (T) => React.Node,
  page: number,
  isCompact?: boolean,
  item: T,
  index: number,
  interstitialComponents?: Array<React.Node>,
  interstitialIndexes?: Array<number>,
};

const useStyles = createUseThemeStyles(styles);

function FeedQueryPageItem<T>({
  renderItem,
  item,
  page,
  index,
  isCompact,
  interstitialComponents,
  interstitialIndexes,
}: Props<T>): React.Node {
  const classes = useStyles({ isCompact });

  const interstitialComponent = feedGetSponsorToInsert(
    index + (page - 1) * 10,
    interstitialIndexes,
    interstitialComponents,
  );

  return (
    <>
      {interstitialComponent && (
        <li data-testid="feed-item" className={classes.feedItem}>
          {interstitialComponent}
        </li>
      )}
      <li data-testid="feed-item" className={classes.feedItem}>
        {renderItem(item)}
      </li>
    </>
  );
}

export default FeedQueryPageItem;
